import React, {forwardRef, useMemo, useState} from 'react';
import Page from "../Container";
import Logo from "../Logo";
import Error from "../../pages/404/Error";
import Preloader from "../Preloader";
import background from './assets/bg_footer.webp';
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { useContacts } from "../../api/api";
import { useTranslation } from "react-i18next";
import styles from './footer.module.scss';

const Footer = forwardRef(({...props}, ref) => {
  const [year] = useState(new Date().getFullYear());
  const [t, i18n] = useTranslation("global");
  const lang = useMemo(() => i18n.language.slice(0, 2), [i18n.language]);

  const { contactsData, isContactsLoading, contactsError } = useContacts(lang);

  const changeLang = (langCode) => {
    i18n.changeLanguage(langCode);
  }

  if (contactsError) {
    return <Error />
  }

  if (isContactsLoading) {
    return <Preloader/>
  }

  const data = contactsData.data;

  return (
    <div className={`section ${styles.wrapper}`} ref={ref}>
      <div className={styles.background}>
        <img src={background} alt='footer' />
      </div>
      { data &&
        <Page className={styles.page}>
          <div className={styles.gridRow}>
            <div>
              <Logo className={styles.logo} />
              { data.socials &&
                <div className={styles.socials}>
                  { data.socials.facebook ?
                    <a className={`${styles.network}`} href={data.socials.facebook} target={'_blank'}>
                      <FaFacebook />
                    </a> : ''
                  }
                  { data.socials.instagram ?
                    <a className={`${styles.network}`} href={data.socials.instagram} target={'_blank'}>
                      <FaInstagram />
                    </a> : ''
                  }
                  { data.socials.linkedin ?
                    <a className={`${styles.network}`} href={data.socials.linkedin} target={'_blank'}>
                      <FaLinkedin />
                    </a> : ''
                  }
                </div>
              }
            </div>
            <div className={styles.subRow}>
              <div>
                { data.phone &&
                  <div className={styles.contactBlock}>
                    <span className={styles.contactTitle}>{t("footer.call_us")}</span>
                    <a href={`tel: ${data.phone}`} className={styles.contactText}>
                      {data.phone}
                    </a>
                  </div>
                }
                { data.address &&
                  <div className={styles.contactBlock}>
                    <span className={styles.contactTitle}>{t("footer.address")}</span>
                    <p className={styles.contactText}>{data.address}</p>
                  </div>
                }
              </div>
              <div>
                { data.partnership &&
                  <div className={styles.contactBlock}>
                    <span className={styles.contactTitleSm}>{t("footer.partners")}</span>
                    <a href={`mailto:${data.partnership}`} className={styles.contactText}>
                      {data.partnership}
                    </a>
                  </div>
                }
                { data.support &&
                  <div className={styles.contactBlock}>
                    <span className={styles.contactTitleSm}>{t("footer.work")}</span>
                    <a href={`mailto:${data.support}`} className={styles.contactText}>
                      {data.support}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className={`${styles.gridRow} ${styles.rightsAndTerms}`}>
            <div className={styles.rights}>
              <p className={`text-copy`}>&copy; {year} RedBark | {t("footer.rights")}</p>
            </div>
            <div className={styles.subRow}>
              <div className={styles.mobileNone}></div>
              <div className={`${styles.terms} text-copy`}>
                <Link to={'/terms'}>{t("footer.terms")}</Link>
                &nbsp;|&nbsp;
                <Link to={'/privacy'}>{t("footer.privacy")}</Link>
              </div>
            </div>
          </div>
          <div className={`${styles.gridRow} ${styles.lang}`}>
            <div className={styles.langBtn} onClick={() => changeLang('en')}>Eng</div>
            <div className={styles.langBtn} onClick={() => changeLang('ru')}>Ru</div>
          </div>
        </Page>
      }
    </div>
  );
});

export default Footer;